import React from 'react';
import {IOrderModel} from '../../src/@interfaces/models/Order/IOrderModel';
import {Props} from '../../src/components/Form/FormField';
import OrderTasksField from '../orders/fields/tasks/OrderTasksField';

export default function TasksTab<Model extends IOrderModel = IOrderModel>(props: Props<Model>) {
    const pseudoOrder: Model = {
        ...props.model,
        id: props.model?.order_id,
    } as any;

    return <OrderTasksField<Model>
            {...props}
            model={pseudoOrder}
    />;
}
